import styled from "styled-components";

export const StepperHeader = styled.div`
	${({ theme }) => theme.drawer.header};
	display: block;
`;
